import { useEffect, useState } from "react";
import { fetchRules, deleteRule } from "./api";
import { FaEdit, FaTrash, FaPlus, FaCheck, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const Rules = () => {
  const [rules, setRules] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadRules();
  }, []);

  const loadRules = async () => {
    const data = await fetchRules();
    setRules(data || []);
  };

  const handleDeleteRule = async (ruleId) => {
    try {
      await deleteRule(ruleId);
      setRules(rules.filter((rule) => rule.id !== ruleId));
      setShowDeleteConfirm(null);
    } catch (error) {
      console.error("Error deleting rule:", error);
    }
  };

  const handleEditRule = (ruleId) => {
    navigate(`/cdp/rules/edit/${ruleId}`);
  };

  return (
    <div className="rules-container">
      {/* Header Section */}
      <div className="rules-header">
        <div className="header-content">
          <h1>Rules Management</h1>
          <Link to="/cdp/rules/create" className="create-rule-btn">
            <FaPlus /> Create New Rule
          </Link>
        </div>

        <div className="search-section">
          <input
            type="text"
            placeholder="Search Rules..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Rules Table */}
      <div className="rules-table-container">
        <table className="rules-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Scope</th>
              <th>Status</th>
              <th>Last Modified</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rules
              .filter((rule) => 
                rule.name.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .map((rule) => (
                <tr key={rule.id}>
                  <td>{rule.name}</td>
                  <td>{rule.description}</td>
                  <td>
                    <span className="scope-badge">{rule.scope}</span>
                  </td>
                  <td>
                    <span className={`status-badge ${rule.enabled ? 'active' : 'inactive'}`}>
                      {rule.enabled ? 'Enabled' : 'Disabled'}
                    </span>
                  </td>
                  <td>{new Date(rule.lastModified).toLocaleDateString()}</td>
                  <td className="actions-cell">
                    <button 
                      className="action-btn edit"
                      onClick={() => handleEditRule(rule.id)}
                    >
                      <FaEdit /> Edit
                    </button>
                    {!rule.readOnly && (
                      <button 
                        className="action-btn delete"
                        onClick={() => setShowDeleteConfirm(rule.id)}
                      >
                        <FaTrash /> Delete
                      </button>
                    )}
                    
                    {/* Delete Confirmation Popup */}
                    {showDeleteConfirm === rule.id && (
                      <div className="delete-confirm-popup">
                        <p>Are you sure you want to delete this rule?</p>
                        <div className="confirm-actions">
                          <button 
                            className="confirm-btn confirm"
                            onClick={() => handleDeleteRule(rule.id)}
                          >
                            <FaCheck /> Yes
                          </button>
                          <button 
                            className="confirm-btn cancel"
                            onClick={() => setShowDeleteConfirm(null)}
                          >
                            <FaTimes /> No
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Rules;
